<template>
  <div
    id="data-list-list-view"
    class="mt-3 data-list-container flipthis-highlight vs-con-loading__container"
  >
    <vs-table
      ref="table"
      :sst="true"
      :data="beneficiarios"
      :max-items="meta.per_page"
      @sort="handleOrdenacao"
      noDataText="Nenhum dado disponível com os filtros selecionados."
    >
      <template slot="thead" v-if="beneficiarios.length">
        <vs-th sort-key="id">#</vs-th>
        <vs-th sort-key="nome">Cliente</vs-th>
        <vs-th sort-key="entidade:id|entidade.nome">Número do documento</vs-th>
        <vs-th sort-key="data_nascimento">Data de Nascimento</vs-th>
        <vs-th sort-key="updated_at">atualização</vs-th>
        <vs-th></vs-th>
      </template>

      <template>
        <tbody>
          <vs-tr
            :data="beneficiario"
            :key="indextr"
            v-for="(beneficiario, indextr) in beneficiarios"
          >
            <vs-td>
              <p class="product-name font-medium main-menu-sidebar">{{ beneficiario.id }}</p>
            </vs-td>

            <vs-td>
              <p class="product-name font-semibold main-menu-sidebar">{{ beneficiario.nome }}</p>
              <span class="flex">
                <small
                  class="product-name inline-flex font-semibold main-menu-sidebar"
                >{{ beneficiario.cpf }}</small>
                <small @click="copiarCpf(beneficiario.cpf)" class="ml-1 inline-flex">
                  <vs-icon icon="file_copy" color="primary"></vs-icon>
                </small>
              </span>
            </vs-td>

            <vs-td>
              <p class="product-category main-menu-sidebar">{{ beneficiario.rg }}</p>
              <small
                class="product-category font-medium main-menu-sidebar"
              >{{ beneficiario.orgao_expeditor }}</small>
            </vs-td>

            <vs-td>
              <p
                class="product-category main-menu-sidebar"
              >{{ beneficiario.data_nascimento | formatarData }}</p>
              <small class="product-category font-medium main-menu-sidebar">{{ beneficiario.valor }}</small>
            </vs-td>

            <vs-td>
              <p class="product-category">{{ beneficiario.created_at | formatarData }}</p>
              <small
                class="product-category font-medium"
              >{{ beneficiario.created_at | formatarHora }}</small>
            </vs-td>

            <vs-td>
              <div class="text-right">
                <vs-dropdown
                  id="btn-ver-mais-clientes"
                  dusk="btn-ver-mais-clientes"
                  class="cursor-pointer"
                  vs-custom-content
                  vs-trigger-click
                >
                  <vs-button
                    class="btn-drop"
                    icon="more_vert"
                    radius
                    size="small"
                    color="#c3c3c3"
                    type="border"
                  ></vs-button>
                  <vs-dropdown-menu>
                    <vs-dropdown-item
                      dusk="abrir-modal"
                      id="abrir-modal"
                      @click="visualizarBeneficiario(beneficiario)"
                    >Visualizar</vs-dropdown-item>
                    <vs-dropdown-item @click="verContratos(beneficiario)">Contratos</vs-dropdown-item>
                  </vs-dropdown-menu>
                </vs-dropdown>
              </div>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
    <paginacao :meta="meta" :handler="handlePaginaSelecionada" />
  </div>
</template>

<script>
export default {
  name: "paginacao-clientes",
  data() {
    return {};
  },
  created() {
    this.$store.dispatch("RESET_BENEFICIARIOS");
    this.buscarBeneficiarios(1);
  },
  watch: {
    $route(to) {
      this.buscarBeneficiarios(to.query.page);
    },
    loading(loading) {
      if (loading) {
        this.$vs.loading({
          container: "#data-list-list-view",
          scale: 0.6
        });
      } else {
        this.$vs.loading.close("#data-list-list-view > .con-vs-loading");
      }
    }
  },
  computed: {
    loading() {
      return this.$store.getters.isBeneficiariosLoading();
    },
    beneficiarios() {
      return this.$store.getters.getBeneficiarios();
    },
    meta() {
      return this.$store.getters.getBeneficiariosMeta();
    }
  },
  methods: {
    copiarCpf(cpf) {
      this.$copyText(cpf);
      this.$vs.notify({
        title: "Sucesso",
        text: "CPF Foi copiado",
        position: "bottom-center"
      });
    },
    visualizarBeneficiario(beneficiario) {
      this.$router.push({
        name: "visualizar-cliente",
        params: { id: beneficiario.id }
      });
    },
    buscarBeneficiarios(page) {
      this.$store.dispatch("FETCH_BENEFICIARIOS", {
        page: page,
        ...this.$route.query
      });
    },
    handlePaginaSelecionada(query) {
      this.$router.push({
        name: "clientes",
        query
      });
    },
    handleOrdenacao(key, active) {
      this.$router.push({
        name: "clientes",
        query: {
          ...this.$route.query,
          sortedBy: active ? "asc" : "desc",
          orderBy: key,
          page: 1
        }
      });
    },
    verContratos(beneficiario) {
      this.$router.push({
        name: "contratos",
        query: { cpf: beneficiario.cpf }
      });
    }
  }
};
</script>
